import { render, staticRenderFns } from "./edit-table-content.vue?vue&type=template&id=68309783&scoped=true&style=overflow%3A%20auto%3B%20height%3A100%25%3B"
import script from "./edit-table-content.vue?vue&type=script&lang=js"
export * from "./edit-table-content.vue?vue&type=script&lang=js"
import style0 from "./edit-table-content.vue?vue&type=style&index=0&id=68309783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68309783",
  null
  
)

export default component.exports